export default {
  name: 'marking--treeMrkDisaggregation',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/disaggr',
  urlParamName: 'marking--treeMrkDisaggregation',
};